import { filterTasksBySearchText } from '@griply/utils';
import { useTasks } from 'features/tasks';
import { useMemo } from 'react';

export const useTextFilteredTasks = (searchText: string) => {
  const tasks = useTasks(undefined, !!searchText);

  return useMemo(
    () => filterTasksBySearchText(tasks, searchText),
    [searchText, tasks],
  );
};
